"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKBottomDrawer = void 0;
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
var React = __importStar(require("react"));
var hooks_1 = require("../../common/hooks");
var GKBottomDrawerContainer_1 = require("./GKBottomDrawerContainer/GKBottomDrawerContainer");
require("./GKBottomDrawer.css");
/**
 * A toggleable bottom drawer component with a title bar and content.
 * Should be a child of GKBottomDrawerContainer.
 */
var GKBottomDrawer = function (props) {
    var drawerContext = React.useContext(GKBottomDrawerContainer_1.GKBottomDrawerContext);
    var mergedProps = (0, hooks_1.useMergedProps)(props, {
        _gkComponentIdentifier: "gk-bottom-drawer",
        className: "d-flex flex-column " + drawerContext.snapClass + (drawerContext.fullscreen ? " fullscreen" : ""),
        style: { height: drawerContext.height },
    });
    var children = mergedProps.children, title = mergedProps.title, toggleText = mergedProps.toggleText, otherProps = __rest(mergedProps, ["children", "title", "toggleText"]);
    return (React.createElement("div", __assign({}, otherProps),
        React.createElement("div", { className: "gk-bottom-drawer-toggle flex-grow-0 text-center", onClick: drawerContext.toggle },
            toggleText && (React.createElement("span", { className: "gk-bottom-drawer-toggle-text", "data-qa": mergedProps["data-qa"] + "--span" }, toggleText[drawerContext.snapPoint])),
            React.createElement("i", { className: "gi" })),
        title && (React.createElement("div", { className: "gk-bottom-drawer-header px-3 flex-grow-0", onClick: drawerContext.toggle }, String(title) === title ? React.createElement("h5", { className: "m-0" }, title) : title)),
        React.createElement("div", { className: "gk-bottom-drawer-content px-3 flex-grow-1" }, children)));
};
exports.GKBottomDrawer = GKBottomDrawer;
